/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PopularPixels, PopularPixelsInterface } from "../PopularPixels";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "verifierAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "Revision",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "PIXEL_BLOCK_SIZE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TOTAL_DIMENSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TOTAL_PIXEL_BLOCKS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAvailablePixelBlocksCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getEncodedSvgUri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getOwnersMap",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
        ],
        internalType: "struct PopularPixels.OwnerMapItem[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRevisionCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSvg",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "save",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newPrice",
        type: "uint256",
      },
    ],
    name: "setPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "verifierAddress",
        type: "address",
      },
    ],
    name: "setVerifierAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class PopularPixels__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    name: string,
    symbol: string,
    verifierAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PopularPixels> {
    return super.deploy(
      name,
      symbol,
      verifierAddress,
      overrides || {}
    ) as Promise<PopularPixels>;
  }
  getDeployTransaction(
    name: string,
    symbol: string,
    verifierAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name,
      symbol,
      verifierAddress,
      overrides || {}
    );
  }
  attach(address: string): PopularPixels {
    return super.attach(address) as PopularPixels;
  }
  connect(signer: Signer): PopularPixels__factory {
    return super.connect(signer) as PopularPixels__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PopularPixelsInterface {
    return new utils.Interface(_abi) as PopularPixelsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PopularPixels {
    return new Contract(address, _abi, signerOrProvider) as PopularPixels;
  }
}
